import getQuerySearchSelect from 'modules/search/selectors/get-query'
import getDomainListPathFromQueryReduxUtil from 'modules/redux/utils/get-domain-list-path-from-query'
import { PLANS_PATH } from 'modules/plan/redux/constants'
import { getDataPathReduxUtil } from '@gymaholic/packages'
import { getObjectUtil } from 'packages/src'

const getRecommendedDomainListDataPlanSelect = state => {
  const query = getQuerySearchSelect(state)
  const path = getDomainListPathFromQueryReduxUtil(PLANS_PATH.RECOMMENDED, query)
  const dataPath = getDataPathReduxUtil(path)
  return getObjectUtil(state, dataPath)
}

export default getRecommendedDomainListDataPlanSelect
